import React, { useEffect, useState } from 'react'
import style from "css/sign.module.css"
import { Button, ConfigProvider, Input, Modal } from 'antd';
import modalStyle from "css/modal.module.css";
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function FindPassword({ sendMailSuccess, sendMailFail }) {
    const { t } = useTranslation();
    const [mail, setMail] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        return () => setMail("");
    }, []);

    useEffect(() => {
        return () => setLoading(false);
    }, []);

    const sendPasswordMail = () => {
        const data = {
            EMAIL: mail
        }

        Modal.destroyAll();

        axios.post("/user/password", data)
            .then(res => {
                if (res.status === 200) {
                    sendMailSuccess(mail);
                }
            })
            .catch(err => {
                sendMailFail(err);
            })
    }

    return (
        <section className={style.password_container}>
            <article className={style.password_comment}>
                {t("MESSAGE.CHANGE_PW_MSG")}
            </article>
            <ConfigProvider
                theme={{
                    components: {
                        Input: {
                            colorPrimaryHover: '#1cb691',
                        },
                        Button: {
                            colorBgContainerDisabled: '#c0c0c0',
                            colorTextDisabled: 'white',
                            colorPrimaryHover: 'black',
                            colorFillSecondary: 'black',
                        }
                    }
                }}
            >
                <Input
                    className={style.item_input}
                    placeholder={t("PLACEHOLDER.INPUT.ENTER_EMAIL")}
                    onChange={e => setMail(e.target.value)}
                    onPressEnter={
                        () => {
                            if (mail.length > 0) {
                                sendPasswordMail();
                            }
                        }
                    }
                />
                <Button
                    className={`${modalStyle.green_full_btn} ${style.password_btn}`}
                    onClick={() => sendPasswordMail()}
                    loading={loading}
                    disabled={mail.length < 1}
                    style={{ fontWeight: 600, fontFamily: 'SpoqaHanSansNeo', border: 'none' }}
                >
                    {t("BTN.SEND_MAIL")}
                </Button>
            </ConfigProvider>
        </section>
    )
}

export default FindPassword
